import "../styles/style.css";

import { createPortal } from "react-dom"


export default function Popup({ image, title, onClose }) {
    return createPortal (
        <div className="popup">
            <div className="popup-content">

                <button className="hamburger-child close-popup" onClick={onClose}>
                    <div></div>
                    <div></div>
                    <div></div>
                </button>

                {/* <div className="hamburger-child">
                </div> */}

                <img src={image} alt={title} />

            </div>
        </div>,
        document.body
    );
}